var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 477.866,
    height: 477.866,
    viewBox: "273.066 273.066 477.866 477.866",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M535.893 512l209.92-209.92c6.827-6.827 6.827-17.067 0-23.893-6.826-6.826-17.065-6.827-23.893 0L512 488.107l-209.92-209.92c-6.827-6.827-17.067-6.827-23.893 0-6.827 6.826-6.827 17.066 0 23.893L488.107 512l-209.92 209.92c-6.827 6.827-6.827 17.067 0 23.893 3.413 3.414 8.533 5.12 11.946 5.12s8.534-1.706 11.947-5.12L512 535.893l209.92 209.92c3.413 3.414 8.533 5.12 11.947 5.12s8.533-1.706 11.945-5.12c6.827-6.825 6.827-17.065 0-23.893L535.892 512z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8476527e.svg";
export { ForwardRef as ReactComponent };